import { combineReducers } from "redux"
import authReducer from "./authreducer"

const rootReducer = combineReducers({
  authReducer,
});

export default rootReducer;